import ProjectsCostPerYearHistogramChart from "./ProjectsCostPerYearHistogramChart";
import ProjectsPerStateDonutChart from "./ProjectsPerStateDonutChart";

const PROJECTS_STATISTICS_WIDGETS = [
  {
    key: "cost-per-state",
    component: <ProjectsPerStateDonutChart valueKey="cost" />,
  },
  {
    key: "count-per-state",
    component: <ProjectsPerStateDonutChart valueKey="count" />,
  },
  { key: "cost-per-year", component: <ProjectsCostPerYearHistogramChart /> },
];

export {
  PROJECTS_STATISTICS_WIDGETS,
  ProjectsCostPerYearHistogramChart,
  ProjectsPerStateDonutChart,
};
